import Icon from '../../../components/AppIcon';
import { WorkflowStep } from '../types';

const HowItWorksSection = () => {
  const steps: WorkflowStep[] = [
    {
      id: "1",
      title: "Audit & Discovery",
      description: "We analyze your manual workflows to find the bottlenecks costing you the most money.",
      icon: "Search"
    },
    {
      id: "2",
      title: "Blueprint Design",
      description: "We map out the perfect automation architecture using n8n, Make.com, or custom code.",
      icon: "Map" // Ensure Map icon exists, or use 'FileText'
    },
    {
      id: "3",
      title: "Build & Integrate",
      description: "Our engineers build the bots, connect the APIs, and test the system rigourously.",
      icon: "Cpu" // Or 'Settings'
    },
    {
      id: "4",
      title: "Handover & Scale",
      description: "We launch the system, train your team, and provide ongoing optimization support.",
      icon: "Rocket"
    }
  ];

  return (
    <section className="bg-background py-20 lg:py-28 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary">
            Your Path to <span className="text-primary">Automation</span>
          </h2>
          <p className="text-lg text-text-secondary">
            We've simplified the complex process of digital transformation into four clear steps.
          </p>
        </div>

        <div className="relative">
          {/* Connecting Line (Desktop Only) */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-primary/30 to-transparent -z-10" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((step, index) => (
              <div key={step.id} className="relative group">
                
                {/* Step Number Badge */}
                <div className="flex justify-center mb-6">
                  <div className="relative flex items-center justify-center w-24 h-24 bg-card border-4 border-background rounded-full shadow-lg group-hover:border-primary/50 transition-colors duration-300 z-10">
                    <Icon name={step.icon} size={32} className="text-primary" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold text-sm border-4 border-background">
                      {index + 1}
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="text-center px-4">
                  <h3 className="text-xl font-bold text-text-primary mb-3">
                    {step.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed text-sm">
                    {step.description}
                  </p>
                </div>
                
                {/* Mobile Connector Line */}
                {index < steps.length - 1 && (
                    <div className="lg:hidden w-0.5 h-12 bg-border mx-auto my-4" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;